import auto1 from '../images/auto_1.jpg';
import auto3 from '../images/auto_3.jpg';
import auto5 from '../images/auto_5.jpg';
import auto6 from '../images/auto_6.jpg';

import energy1 from '../images/energy_1.jpg';
import energy3 from '../images/energy_3.jpg';
import energy5 from '../images/energy_5.jpg';
import energy7 from '../images/energy_7.jpg';
import energy8 from '../images/energy_8.jpg';
import energy14 from '../images/energy_14.jpg';
import energy19 from '../images/energy_19.jpg';
import energy23 from '../images/energy_23.jpg';
import energy_pv1 from '../images/energy_private_1.jpg';
import energy_pv3 from '../images/energy_private_3.jpg';
import energy_pv5 from '../images/energy_private_5.jpg';
import energy_pv8 from '../images/energy_private_8.jpg';
import energy_pv10 from '../images/energy_private_10.jpg';
import energy_pv13 from '../images/energy_private_13.jpg';

import heavy_ugl3 from '../images/heavy_ugl3.jpg';
import heavy_ugl4 from '../images/heavy_ugl4.jpg';
import heavy_ugl5 from '../images/heavy_ugl5.jpg';
import heavy_ugl6 from '../images/heavy_ugl6.jpg';

import teleco2 from '../images/teleco_2.jpg';
import teleco3 from '../images/teleco_3.jpg';
import teleco5 from '../images/teleco_5.jpg';
import teleco7 from '../images/teleco_7.jpg';
import teleco9 from '../images/teleco_9.jpg';
import teleco13 from '../images/teleco_13.jpg';
import teleco15 from '../images/teleco_15.jpg';
import teleco19 from '../images/teleco_19.jpg';

import glacier6 from "../images/water_glacier6.jpg";
import glacier7 from "../images/water_glacier7.jpg";
import glacier9 from "../images/water_glacier9.jpg";
import glacier16 from "../images/water_glacier16.jpg";
import glacier22 from "../images/water_glacier22.jpg";

import nubian1 from "../images/water_nubian1.jpg";
import nubian3 from "../images/water_nubian3.jpg";
import nubian7 from "../images/water_nubian7.jpg";


const galleryImages = [
  // Automotive
  {
    image: auto1, 
    category: "automotive", 
    title: 'Miscellaneous', 
    comment: "Miscellaneous project by the custom bus group" 
  },
  {
    image: auto3, 
    category: "automotive", 
    title: 'Miscellaneous', 
    comment: "Miscellaneous project by the custom bus group"
  },
  {
    image: auto5, 
    category: "automotive", 
    title: 'Miscellaneous', 
    comment: "Miscellaneous project by the custom bus group"
  },
  {
    image: auto6, 
    category: "automotive", 
    title: 'Miscellaneous', 
    comment: "Miscellaneous project by the custom bus group"
  },

  // Energy
  {
    image: energy1, 
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy3,
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy5,
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy7, 
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },

  {
    image: energy8, 
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy14, 
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy19, 
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy23, 
    category: "energy", 
    title: '2.5MW Generators', 
    comment: "2.5MW generators by the MPower"
  },
  {
    image: energy_pv1, 
    category: "energy", 
    title: 'Portable Solar System', 
    comment: "Portable Solar System by private client"
  },
  {
    image: energy_pv3, 
    category: "energy", 
    title: 'Portable Solar System', 
    comment: "Portable Solar System by private client"
  },
  {
    image: energy_pv5, 
    category: "energy", 
    title: 'Portable Solar System', 
    comment: "Portable Solar System by private client"
  },
  {
    image: energy_pv8, 
    category: "energy", 
    title: 'Portable Solar System', 
    comment: "Portable Solar System by private client"
  },
  {
    image: energy_pv10, 
    category: "energy", 
    title: 'Portable Solar System', 
    comment: "Portable Solar System by private client"
  },
  {
    image: energy_pv13, 
    category: "energy", 
    title: 'Portable Solar System', 
    comment: "Portable Solar System by private client"
  },

  // Heavy
  {
    image: heavy_ugl3,
    category: 'mining- heavy industory',
    title: 'Pump Unit',
    comment: 'Pump unit by UGL'
  },
  {
    image: heavy_ugl4,
    category: 'mining- heavy industory',
    title: 'Pump Unit',
    comment: 'Pump unit by UGL'
  },
  {
    image: heavy_ugl5,
    category: 'mining- heavy industory',
    title: 'Pump Unit',
    comment: 'Pump unit by UGL'
  },
  {
    image: heavy_ugl6,
    category: 'mining- heavy industory',
    title: 'Pump Unit',
    comment: 'Pump unit by UGL'
  },

  // Telecom
  {
    image: teleco2,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco3,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco5,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco7,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco9,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco13,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco15,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },
  {
    image: teleco19,
    category: "telecommunication", 
    title: 'Power CSD', 
    comment: "Power CSD by Produce Development"
  },

  // Water
  {
    image: nubian1,
    category: 'water',
    title: 'Greywater Treatment System',
    comment: 'Greywater Treatment System by Nubian'
  },
  {
    image: nubian3,
    category: 'water',
    title: 'Greywater Treatment System',
    comment: 'Greywater Treatment System by Nubian'
  },
  {
    image: nubian7,
    category: 'water',
    title: 'Greywater Treatment System',
    comment: 'Greywater Treatment System by Nubian'
  },
  {
    image: glacier6,
    category: 'water',
    title: 'Greywater Treatment System',
    comment: 'Greywater Treatment System by Nubian'
  },

  {
    image: glacier7,
    category: 'water',
    title: 'Filtration Vessels',
    comment: 'Filtration Vessels by Glacier Filtration'
  },
  {
    image: glacier9,
    category: 'water',
    title: 'Filtration Vessels',
    comment: 'Filtration Vessels by Glacier Filtration'
  },
  {
    image: glacier16,
    category: 'water',
    title: 'Filtration Vessels',
    comment: 'Filtration Vessels by Glacier Filtration'
  },
  {
    image: glacier22,
    category: 'water',
    title: 'Filtration Vessels',
    comment: 'Filtration Vessels by Glacier Filtration'
  },

];


export { galleryImages } ;